import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window back to the top of the page whenever the route path changes.
 * Place this once inside <Router> so it applies to every navigation.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Defer to next tick so the new route has rendered before we scroll
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
